import { mercuryApi, webApi } from '$api'

import { LoadedInvoice, Subscription } from './types'

/** Fetches every subscription the signed-in user owns. */
export async function getSubscriptions(): Promise<readonly Subscription[]> {
  return (await mercuryApi.get<Subscription[]>('/subscriptions')) ?? []
}

/**
 * Fetches all invoices. `page=0&pageSize=0` tells the API to return everything.
 *
 * The response body IS the invoices array directly - there is no `{ data: [] }`
 * envelope.
 */
export async function getInvoices(): Promise<readonly LoadedInvoice[]> {
  const invoices = await webApi.get<readonly LoadedInvoice[]>(
    '/r/LoadedInvoices?page=0&pageSize=0'
  )
  return invoices ?? []
}
